
(function(){
    angular.module('tmx-app').controller('loanApplicationCtrl', [ '$mdDialog', '$state','LoanApplicationService','LoanProductService',
        'lookupService','$mdSidenav','resolvedData','tmxUtility','menu','tmxResource', 'TmxDialogService','ToastService','$filter','TMX_FINANCE_CONSTANTS','cacheStore',

        function LoanApplicationCtrl($mdDialog, $state, LoanApplicationService,LoanProductService, 
            lookupService,$mdSidenav,resolvedData,tmxUtility,menu,tmxResource,TmxDialogService,ToastService,$filter,TMX_FINANCE_CONSTANTS,cacheStore){
            
        //#region ------- Dev Notes ------------------

        //#endregion

        //#region --- Variable Declaration & Initialization--------
            var vm=this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            vm.formatDate = tmxUtility.formatDateForCompany;
            vm.formatDateTime = tmxUtility.formatDateTimeForCompany;            
            vm.checkPermission = tmxUtility.checkPermission;
            vm.menu = menu;
            vm.isPageLoading = false;

            vm.query = "LoanApplication";
            vm.gridData = new kendo.data.ObservableArray([]);
            vm.date = new Date().toJSON();
            vm.cols = LoanApplicationService.filterColumn;
            vm.nav = "SearchSideNav";
            vm.schema = LoanApplicationService.schema;
            vm.cloneColumn = LoanApplicationService.gridColumn;
            vm.LoanApplicationService = LoanApplicationService;
            vm.LoanProducts=resolvedData.loanProducts.data;
            vm.userBanches = resolvedData.userBranches.data;
            vm.gridColumns=LoanApplicationService.gridColumns;
            vm.Columns=LoanApplicationService.cols;
            var LoanApplicationStatus =  resolvedData.LoanStatus;
            vm.gridColumns[0].template=formatLoanApplicationName;

            vm.editPermission=vm.checkPermission('Private.Transaction.LoanApplication','Edit');
            vm.filterChips = [];
            var previousSelectedChip = null;
            // var culture=kendo.culture();
            // culture.numberFormat.currency.symbol = "PKR. "; Should be in configurations


        //#endregion


        //#region ----- Local Functions-----------

            function formatLoanApplicationName (item){
                var id=item.LoanApplicationId;
        // ng-disabled="!LoanApplicationCtrl.EditPrivilege"
                var template='<md-button ng-disabled="!LoanApplicationCtrl.editPermission" class="tmx-primary-text-grid" ng-disabled="!LoanApplicationCtrl.editPermission"  ng-click="LoanApplicationCtrl.goToEditId('+id+')">'+item.LoanApplicationNumber+'</md-button> <div class="margin-bottom-2"> <span class="chip" ng-style={{dataItem.StatusBKColor}}> '+item.Status+ '</span> </div>';
                return template;
            }         

            function InitializeGrid() {
                vm.filters = {};
                vm.mainGridOptions = {
                    dataSource: {
                        transport: {
                            read: function(o){
                             
                                if(angular.isDefined(vm.searchClear) && vm.searchClear==false){
                                    if(exists(vm.o)){
                                        copy(vm.o.data,["filter"],o.data);
                                    }
                                }
                                vm.searchClear = false;
                                if(vm.onChildState()){return;}
                                if(!o.fromSideNav) {
                                    if($state.searchClear){
                                        vm.searchClear = true;
                                        $state.searchClear=undefined;
                                    }
                                }
                                else{
                                    o.data.firstPage = true;
                                }
    
    
                                vm.o = angular.copy(o);
                                vm.filters = vm.o.data.filter;
                                vm.isPageLoading = true;
                                tmxResource("LoanApplication/List").getByParams(o,true).then(function(response){
                                    parseResppnse(response.data);
                                    vm.exportData=response;
                                    o.success(response);
                                    vm.isPageLoading = false;
                                });
                            },
    
                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
    
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort:  [{field: "loanApplicationId", dir: "desc"}]
                    },
                    excelExport: function(e) {                              
                        var sheet = e.workbook.sheets[0];
                        var data = vm.exportData.data;
                        
                        var gridColumns = vm.container.LoanApplicationGrid.columns;                    
                        var filteredColumns=filterdColumns(gridColumns);
                        var columns = tmxUtility.columnsMapping(filteredColumns);                    
                        var rows=tmxUtility.dataMapping(data,columns);      
                        sheet.rows = rows;                                                                 
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: true,
                        pageSize: 10,
                        buttonCount: 5,
                    },
                    pdf: {
                        allPages: true,
                        fileName: "LoanApplications.pdf"
                    },
                    excel: {
                  /*  allPages: true,*/
                        fileName: "LoanApplications.xlsx"
                    },
    
                    sortable: true,
                    scrollable: false,
                    columns: vm.gridColumns
                };


                function parseResppnse(data){
                    data.forEach(function(dataItem){                                                                            
                        dataItem.FullName=vm.formatFullName(dataItem.FullName);    
                        dataItem.NationalIdentifierValue=vm.formatCNICNumber(dataItem.NationalIdentifierValue);  
                        dataItem.CreatorName=vm.formatUser(dataItem.CreatorName);  
                        dataItem.FormattedLoanApplicationDate =vm.formatDate(dataItem.LoanApplicationDate);      
                        dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);
                    });          
                    
                    vm.deleteEntityPermission=vm.checkEntityPermission("Delete");
                    vm.assignEntityPermission=vm.checkEntityPermission("Assign");
                }

                vm.searchSideNavActive=false;
                vm.container = {};//defining the object for grid access in controller
                $state.data= {
                    grid: vm.container,
                    mainGridOptions: angular.copy(vm.mainGridOptions)
                };
            }


            function filterdColumns(gridColumns){
                var columns=[];       
                gridColumns.map(function(col){
                    if(col.field=="FullName"){
                        if(!col.hidden){                        
                            columns.push(col);                         
                        }
                    }
                    else if(col.field=="CustomerName"){                        
                        if(!col.hidden){
                            columns.push(col);                         
                        }
                    }
                    else{
                        columns.push(col); 
                    }
                });
                return columns;
            }
            function PrepareLovs(){
                if(tmxUtility.exists(resolvedData.productTypesLkp)){
                    let loanProductLkpIds = resolvedData.productTypesLkp.filter(x=>x.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.LoanProduct).map(x=> x.LookupId);
                    vm.LoanProducts = vm.LoanProducts.filter(product =>  loanProductLkpIds.includes(product.ProductTypeLkp));
                }
                PrepareFilterChips();
            }
            function PrepareFilterChips(){
                let roleStatusLookups = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.ROLE_STATUS_MAPPING);
                let loggedinUserInfo = cacheStore.get('GetInfoOfLoggedInUser');
                if(!exists(loggedinUserInfo)){
                    return;
                }
                let roleStatusMappingItem = roleStatusLookups.find(x=>x.HiddenValue.toLowerCase() == loggedinUserInfo.RoleName.toLowerCase());
                if(!exists(roleStatusMappingItem)){
                    return;
                }          
                vm.filterChips = roleStatusMappingItem.Description.split(',').map(x=>({Name:x.trim(),Style:'default'}));
                if(vm.filterChips.length > 0){
                    vm.filterChips.unshift({Name:'All',Style:'active'}); // Add 'All' on the begining of the array
                    previousSelectedChip = 'All';
                }
            }
        //#endregion

        //#region  -------- Scope Functions -----------
        
            
            vm.getMenu = function() {
                if(angular.isDefined(menu.pages.sections)){
                    for(var i=0;i<menu.pages.sections.length;i++){
                        var section = menu.pages.sections[i];
                        if(angular.isDefined(section.pages) && section.pages != null && section.pages.length>0){
                            for(var j=0;j<section.pages.length;j++){
                                if(section.pages[j].name ==  vm.EntityName){
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };
            vm.showProcessDiagram=function(dataitem){
                switch(dataitem.Status){

                case "Ready For Verification":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Review.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Approved":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Loan Approved.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Need More Clarification":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Draft.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Re Verify Application":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Verification.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Verified":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Review.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Completed":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Completed.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Ready For Approval":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/BM Verification.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;


                case "Draft":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Draft.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;

                case "Rejected":
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/Loan Rejected.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;

                default:
                    $mdDialog.show({
                        template: '<md-dialog aria-label="Process Diagram">' +
                        '<form ng-cloak>' +
                        ' <md-dialog-content> ' +
                        '<div class="md-dialog-content">' +
                        ' <img style="margin: auto; max-width: 100%;"  src="assets/images/NoHighlightedState.png">' +
                        '</div> ' +
                        '</md-dialog-content>' +
                        '</form></md-dialog>',
                        clickOutsideToClose:true,
                    });
                    break;

                }

            }
            vm.getLookupName=function (ApplicationStatusLkpId) {
                var result = "N/A";
                if(!angular.isArray(LoanApplicationStatus)){
                    return result;
                }
                LoanApplicationStatus.forEach(function(loanAppStatusLookup) {

                    if (loanAppStatusLookup.HiddenValue == ApplicationStatusLkpId) {
                        result = loanAppStatusLookup.VisibleValue;
                    }
                });
                return result;
            }

            vm.gotoAdd=function(productId, branchId){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".add",{Id:productId,branchId:branchId,callbackState:$state.current.name});
            }

            vm.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }

            vm.goToEdit=function(application){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                var id=application.LoanApplicationId;
                $state.go($state.current.name+".edit",{Id:id,callbackState:$state.current.name});
            }
            vm.goToEditId=function(id){
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{Id:id,callbackState:$state.current.name});
            }

            vm.checkEntityPermission = function(privilegeName) {
                return !vm.checkPermission('Private.Transaction.LoanApplication',privilegeName);
            }

            vm.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            vm.clickDelete = function(item) {
                let messageText = 'Are you sure you want to cancel this Loan Application?';
                let messageTitle = `Cancel Loan Application ${item.LoanApplicationNumber} ?`
                TmxDialogService.showConfirmDialog(messageTitle,messageText,deleteLoanApplication);
                function deleteLoanApplication() {
                    LoanApplicationService.CancelById(item.LoanApplicationId).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
            };

            vm.clickAssign = function(item){

                LoanProductService.getStatesbyProduct(item.LoanProductId).then(function(response){

                    $mdDialog.show({
                        controller: ['$mdDialog','$scope','tmxUtility','lookupService','TMX_FINANCE_CONSTANTS', 'data','states',  assignController],
                        locals: {
                            data: item,
                            states: response.data
                        },
                        templateUrl: 'app/private/transaction/assign-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        fullscreen: true
                    }).then(function (returnData) { // After closing the dialog
                        if(!tmxUtility.exists(returnData)){
                            return;
                        }
                        let data = returnData;
                        data.PreviousStatusLkp = item.ApplicationStatusLkp;
                        data.ProcessId = item.ProcessInstanceID;
                        data.ApplicationId = item.LoanApplicationId;
                        LoanApplicationService.setApplicationState(data).then(function(result){
                            if(result.data && result.status.code == "200" &&  result.data.Success == true){
                                ToastService.showCustomToast("success", $filter('translate')("StateChangeSuccess"));
                                $('#grid').data('kendoGrid').dataSource.read();
                                return;
                            }
                            ToastService.showCustomToast("error", $filter('translate')("StateChangeError"));
                        });

                    }, function () {
    
                    });
                });
            }

            vm.clickAdd = function () {
                $mdDialog.show({
                    controller: ['$mdDialog', '$scope', 'tmxUtility', 'products', 'branches', productSelectionController],
                    locals: {
                        products: vm.LoanProducts,
                        branches: vm.userBanches
                    },
                    templateUrl: 'app/private/transaction/product-selection-dialog.html',
                    clickOutsideToClose: false,
                    fullscreen: true

                }).then(function (returnData) {
                    if (!tmxUtility.exists(returnData)) {
                        return;
                    }
                    vm.gotoAdd(returnData.ProductId, returnData.BranchId);
                });
            }

            vm.onChipClick = function(selectedChip){
                if(previousSelectedChip == selectedChip.Name){
                    return;
                }
                previousSelectedChip = selectedChip.Name;
                vm.filterChips.forEach(x=>x.Style ='default');
                selectedChip.Style = 'active';

                if(exists(vm.o.data.filter)){
                    // If there is previous filter applied then remove the 'Status' Filter
                    vm.o.data.filter.filters =vm.o.data.filter.filters.filter(x=>x.field != 'Status');
                }
                else {
                    //Initialize the filters
                    vm.o.data.filter = {
                        filters:[],
                        logic:'and'
                    }
                }
                if(selectedChip.Name.toLowerCase() != 'all'){
                    var chipFilter = {
                        field:'Status',
                        operator:'contains',
                        value:selectedChip.Name
                    }
                    vm.o.data.filter.filters.push(chipFilter);
                }
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);
            }

            
            vm.formatDateTime = function(dateObj){
                return tmxUtility.formatDateSpecific(dateObj,"DD/MMM/YYYY hh:mma");
            }

//*******************KENDO*********************//            
            vm.isFiltered=function(fieldName){
                var filtered = false;
                if(angular.isDefined(vm.filters)) {
                    vm.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }
            vm.formatCustomerName=function(dataitem){
                return dataitem.CustomerName;
            };

            vm.formatString=function(value){
                if(!value) {
                    return "N/A";
                }
                else {
                    return value;
                }                        
            };

            vm.formatUser=function(value){
                if(!value) {
                    return "";
                }
                else {
                    return value;
                }                        
            };

            vm.formatFullName=function(dataitem){
                return dataitem;
            };
            vm.formatCNICNumber=function(dataitem){
                if(!dataitem) return "";
                return dataitem;
            };
         
            vm.toggleSearch=function(){
                if(vm.searchSideNavActive) {
                    vm.searchData = {};
                    vm.searchSideNavActive=false;
                }
                else
                    vm.searchSideNavActive=true;
                vm.toggle('SearchSideNav');
            }
            vm.exportSideNavActive=false;

            vm.toggleExport=function(){
                if(vm.exportSideNavActive)
                    vm.exportSideNavActive=false;
                else
                    vm.exportSideNavActive=true;
                vm.toggle('ExportSideNav');
            }

            vm.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            vm.search = function(navID) {

                let calls=[];
                for (var key in vm.searchData) {
                    if (vm.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: vm.searchData[key]
                        });
                    }
                }

                vm.filt = {
                    filters: calls,
                    logic: "and"
                };
                vm.o.data.filter = vm.filt;
                vm.container.LoanApplicationGrid.dataSource.transport.read(vm.o);

                vm.searchData = {};
                vm.toggle(navID);
            };

            vm.clear = function(navID) {
                vm.searchData = {};
                vm.toggle(navID);
            };


            vm.formatLoanAmount=function(Amount){
                if(Amount <=0){
                    return "N/A";
                }
                else {
                    return Amount;

                }
            }

            vm.formatTenure=function(Tenure){
                if(parseInt(Tenure, 10)<=0){
                    return "N/A";
                }
                else {
                    return Tenure;

                }
            }
            //#endregion

            //#region  --Child Controllers-----

            function assignController($mdDialog,$scope, tmxUtility, lookupService, TMX_FINANCE_CONSTANTS, data,states) {

                $scope.availableStates = [];
                $scope.availableStatuses = [];
                $scope.data = data;
                $scope.showLoanEditableFields = false;

                $scope.ok = function(){

                    $scope.assignDialogCtrl.dialogForm.$submitted = true;
                    if(!$scope.assignDialogCtrl.dialogForm.$valid){
                        return;
                    }
                    let returnData = {
                        State:$scope.selectedState,
                        ApplicationStatusLkp: $scope.selectedStatus,
                        Comments: $scope.comments
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function(){
                    $mdDialog.hide();
                }

                function InitializeData(){
                    if(tmxUtility.exists(states) && states.length > 0){
                        $scope.availableStates = states.filter(x=>x.Name.trim() != "")
                            .map(x=> ({
                                HiddenValue : x.Name,
                                VisibleValue: x.VisibleName
                            }));
                    }

                    $scope.availableStatuses = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.APPLICATION_STATUS);
                    
                    $scope.availableStates = tmxUtility.orderArrayByProperty($scope.availableStates ,['VisibleValue'],['asc']);
                    $scope.availableStatuses = tmxUtility.orderArrayByProperty($scope.availableStatuses ,['VisibleValue'],['asc']);

                }

                (function InitializePage(){
                    InitializeData();
                })();
            }

            function productSelectionController($mdDialog, $scope, tmxUtility, products, branches) {
                $scope.availableProducts = [];
                $scope.userBranches = [];
                $scope.disableBranchSelection = false;


                $scope.ok = function () {

                    $scope.productSelectionCtrl.dialogForm.$submitted = true;
                    if (!$scope.productSelectionCtrl.dialogForm.$valid) {
                        return;
                    }
                    let returnData = {
                        ProductId: $scope.selectedProduct,
                        BranchId: $scope.selectedBranch
                    }
                    $mdDialog.hide(returnData);
                }

                $scope.cancel = function () {
                    $mdDialog.hide();
                }

                function InitializeData() {
                    $scope.availableProducts = products.map(x => ({ LookupId: x.ProductId, VisibleValue: x.ProductName }));
                    if (tmxUtility.exists(branches)) {
                        $scope.userBranches = branches.map(x => ({ LookupId: x.CompanyBranchId, VisibleValue: x.BranchName }));
                        if ($scope.userBranches.length == 1) { // If there is only one branch associated, then by default make it selected and disabled
                            $scope.selectedBranch = $scope.userBranches[0].LookupId;
                            $scope.disableBranchSelection = true;
                        }
                    }
                }

                (function InitializeDialog() {
                    InitializeData();
                })();
            }

            //#endregion

            
            // eslint-disable-next-line no-unexpected-multiline
            (function InitializePage(){
                InitializeGrid();
                PrepareLovs();
            })();
            
        }
    ]);
})();

